import { render, staticRenderFns } from "./jygm-three-diagram.vue?vue&type=template&id=976db04c&scoped=true&"
import script from "./jygm-three-diagram.vue?vue&type=script&lang=js&"
export * from "./jygm-three-diagram.vue?vue&type=script&lang=js&"
import style0 from "./jygm-three-diagram.vue?vue&type=style&index=0&id=976db04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976db04c",
  null
  
)

export default component.exports